<form [formGroup]="formRelatorios">
  <breadcrumb
  [paginas]="[{route:'/home',name:'Home'},{route:'/consolidado',name:'Relatório'}]"
/>

  <section class="header-page-relatorio">
    <div class="container">
      <h2>
        Relatório
      </h2>
      <section class="section-saudacao header-page-voltar" *ngIf="ativarCampoPeriodo">
        <div class="periodo">
            <p><b>Pesquisar por período:</b></p>
            <div class="periodo-input">
              <input
              type="date"
              name="dataInicial"
              min="{{minDate}}"
              max="{{maxDate}}"
              (blur)="validaAno(this.form.dataInicio)"
              formControlName="dataInicio"
              (change)="carregarCombos()"
              />
              &nbsp;-&nbsp;
              <input
              type="date"
              name="dataFinal"
              min="{{minDate}}"
              max="{{maxDate}}"
              (blur)="validaAno(this.form.dataFim)"
              formControlName="dataFim"
              (change)="carregarCombos()"
              />
            </div>
          </div>
      </section>
    </div>
  </section>

  <section class="section-filtro" >
      <div class="container">
        <div class="conteudo-filter" [class.conteudo-filter-wrap]="ativarBuscaGeralJornada">
          <div class="grupo-filter" *ngIf="ativarCampoPolo">
            <p><b>Polo</b></p>
            <ng-select
              [items]="polos"
              bindLabel="descricaoPolo"
              bindValue="codigoPolo"
              placeholder="Selecione um Polo"
              formControlName="codigoPolo"
              name="codigoPolo"
              (change)="OnChangePolo()">
            </ng-select>
          </div>
          <div class="grupo-filter" *ngIf="ativarCamposDiretoriaEscola">
            <p><b>URE</b></p>
            <ng-select
            [items]="diretorias"
            bindLabel="nomeDiretoria"
            bindValue="codigoDiretoria"
            placeholder="Selecione uma URE"
            formControlName="codigoDiretoria"
            name="codigoDiretoria"
            (change)="getEscolas()"
            >
          </ng-select>
          </div>
          <div class="grupo-filter" *ngIf="ativarCamposDiretoriaEscola">
            <p><b>Escola</b></p>
            <ng-select
            [items]="escolas"
            bindLabel="nomeEscola"
            bindValue="codigoEscola"
            placeholder="Selecione uma Escola"
            formControlName="codigoEscola"
            name="codigoEscola"
            (change)="getCategorias()"
            >
          </ng-select>
          </div>
          <div class="grupo-filter" *ngIf="ativarCamposUsuario || ativarCamposPsicologo || ativarCamposOcorrenciasAtivas">
            <label for="select-categoria">Categoria</label>
            <ng-select
              [items]="categorias"
              bindLabel="descricaoSubCategoria"
              bindValue="codigoSubCategoria"
              placeholder="Selecione uma Categoria"
              name="codigoSubCategoria"
              (change)="getPerfis()"
              formControlName="codigoSubCategoria">
              <ng-template ng-optgroup-tmp let-item="item">
                {{ item.descricaoCategoria || "Unnamed group" }}
              </ng-template>
            </ng-select>
          </div>
          <div class="grupo-filter" *ngIf="ativarCamposUsuario">
            <label for="select-perfil">Perfil</label>
            <ng-select
              [items]="perfis"
              bindLabel="descricaoPerfil"
              bindValue="codigoPerfil"
              placeholder="Selecione um Perfil"
              name="codigoPerfil"
              formControlName="codigoPerfil"
              (change)="getUsuarios()">
            </ng-select>
          </div>
          <div class="grupo-filter" *ngIf="ativarCamposUsuario">
            <label for="select-usuario">Usuario</label>
            <ng-select
              [items]="usuarios"
              bindLabel="nome"
              bindValue="cpf"
              placeholder="Selecione um Usuario"
              name="cpf"
              formControlName="cpf">
            </ng-select>
          </div>

          <div class="grupo-filter" *ngIf="ativarCamposOcorrenciasAtivas">
            <label for="filtro-ativo">Ativo</label>
            <ng-select
              [items]="flagAtivo"
              bindLabel="name"
              bindValue="id"
              class="select-ativo"
              placeholder="Selecione uma Opção"
              formControlName="codigoAtivo"
              name="codigoAtivo"
            >
            </ng-select>
          </div>

          <div class="grupo-filter" *ngIf="ativarBuscaGeralJornada">
            <p><b>Jornada</b></p>
            <input type="text" inputmode="numeric" class="input-filtro" formControlName="codigoJornada" placeholder="Código" autocomplete="off" />
          </div>
          <div class="grupo-filter" *ngIf="ativarBuscaGeralJornada">
            <p><b>CPF</b></p>
            <input type="text" inputmode="numeric" class="input-filtro" formControlName="cpfBusca" placeholder="CPF" autocomplete="off" />
          </div>
          <div class="grupo-filter" *ngIf="ativarCampoStatusPmce">
            <p><b>Status PMCE</b></p>
            <ng-select
              [items]="statusPlanoMelhoriaOptions"
              bindLabel="name"
              bindValue="id"
              class="select-ativo"
              placeholder="Todos"
              formControlName="statusPlanoMelhoria"
              name="statusPlanoMelhoria"
            >
            </ng-select>
          </div>


        </div>
        <p class="filtro-busca-hint" *ngIf="ativarBuscaGeralJornada">
          Preencha um ou mais filtros. A busca considera apenas o que estiver informado.
        </p>
      </div>
  </section>

  <section class="conteudo-relatorio">
    <div class="container">
      <div class="relatorio-acoes">
        <div class="grup-input">
          <label>Selecione o Relatório:</label>
          <ng-select
            [items]="relatorios"
            bindLabel="name"
            bindValue="id"
            class="select-ativo"
            placeholder="Selecione um Relatório"
            formControlName="idRelatorio"
            name="idRelatorio"
            (change)="onOptionsSelected()">
          </ng-select>
        </div>
        <div class="grup-input grup-input-checkbox" *ngIf="ativarCampoDivergenciaPmce">
          <label class="checkbox-label">
            <input type="checkbox" class="checkbox" formControlName="somenteDivergencia" />
            <i></i>
            Somente com divergência de vínculo
          </label>
        </div>
        <div class="grup-input grup-input-checkbox" *ngIf="ativarPainelDuplicatasPrevencaoPoc">
          <label class="checkbox-label">
            <input
              type="checkbox"
              class="checkbox"
              [checked]="incluirAprovadosDuplicatas"
              (change)="incluirAprovadosDuplicatas = $any($event.target).checked" />
            <i></i>
            Mostrar aprovados (PEC)
          </label>
        </div>
        <div class="relatorio-botoes">
          <button class="btn-primary btn-relatorio" type="button" (click)="gerarRelatorio()">
            {{ ativarBuscaGeralJornada ? 'Buscar' : ((ativarPainelDataRegistroOrfa || ativarPainelDuplicatasPrevencaoPoc || ativarPainelCorrecaoCamposAcoesPmce) ? 'Diagnosticar' : 'Gerar') }}
          </button>
          <button
            *ngIf="ativarBuscaGeralJornada && listaBuscaGeralJornada?.length"
            class="btn-primary btn-relatorio btn-exportar"
            type="button"
            (click)="ExportarBuscaGeralJornada()">
            Exportar Excel
          </button>
          <button
            *ngIf="ativarPainelDataRegistroOrfa && listaDataRegistroOrfa?.length"
            class="btn-primary btn-relatorio btn-exportar"
            type="button"
            (click)="ExportarDataRegistroOrfa()">
            Exportar Excel
          </button>
          <button
            *ngIf="ativarPainelDataRegistroOrfa && listaDataRegistroOrfa?.length"
            class="btn-primary btn-relatorio btn-corrigir"
            type="button"
            (click)="CorrigirDataRegistroOrfa()">
            Corrigir
          </button>
          <button
            *ngIf="ativarPainelDuplicatasPrevencaoPoc && listaDuplicatasPrevencaoPoc?.length"
            class="btn-primary btn-relatorio btn-inativar-duplicatas"
            type="button"
            [disabled]="totalDuplicatasSelecionadas === 0"
            (click)="InativarDuplicatasSelecionadas()">
            Inativar selecionados ({{ totalDuplicatasSelecionadas }})
          </button>
        </div>
      </div>
    </div>
  </section>

  <section class="conteudo-relatorio painel-data-registro-orfa painel-busca-jornada" *ngIf="ativarBuscaGeralJornada && listaBuscaGeralJornada?.length">
    <div class="container">
      <div class="tabela-orfa">
        <table>
          <thead>
            <tr>
              <th>Jornada</th>
              <th>CPF</th>
              <th>Nome</th>
              <th>URE</th>
              <th>Escola</th>
              <th>Início</th>
              <th>Fim</th>
              <th>Status</th>
              <th>Ativo</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let item of listaBuscaGeralJornada">
              <td>{{ item.codigoJornada }}</td>
              <td>{{ item.cpf }}</td>
              <td>{{ item.nome }}</td>
              <td>{{ item.codigoDiretoria }} - {{ item.nomeDiretoria }}</td>
              <td>{{ item.codigoEscola }} - {{ item.nomeEscola }}</td>
              <td>{{ item.dataInicio | date:'dd/MM/yyyy HH:mm' }}</td>
              <td>{{ item.dataFim | date:'dd/MM/yyyy HH:mm' }}</td>
              <td>{{ statusJornadaBusca(item) }}</td>
              <td>{{ item.flAtivo === 1 ? 'Sim' : 'Não' }}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </section>

  <section class="conteudo-relatorio painel-data-registro-orfa" *ngIf="ativarPainelDataRegistroOrfa">
    <div class="container">
      <div class="resumo-orfa" *ngIf="resumoDataRegistroOrfa">
        <p><b>Total atividades:</b> {{ resumoDataRegistroOrfa.totalAtividades }}</p>
        <p><b>Com log:</b> {{ resumoDataRegistroOrfa.comLog }}</p>
        <p><b>Sem log (órfãs):</b> {{ resumoDataRegistroOrfa.semLog }}</p>
        <p><b>Sem log — Acolhimento Agendado:</b> {{ resumoDataRegistroOrfa.semLogAcolhimentoAgendado }}</p>
      </div>

      <div class="tabela-orfa" *ngIf="listaDataRegistroOrfa?.length">
        <table>
          <thead>
            <tr>
              <th>Jornada</th>
              <th>Atividade</th>
              <th>Título</th>
              <th>Tipo</th>
              <th>Data visita</th>
              <th>URE</th>
              <th>Escola</th>
              <th>Hipótese</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let item of listaDataRegistroOrfa">
              <td>{{ item.codigoJornada }}</td>
              <td>{{ item.codigoAtividade }}</td>
              <td>{{ item.titulo }}</td>
              <td>{{ item.tipoAtividadeDescricao }}</td>
              <td>{{ item.dataAtividade | date:'dd/MM/yyyy' }}</td>
              <td>{{ item.nomeDiretoria }}</td>
              <td>{{ item.nomeEscola }}</td>
              <td>{{ item.hipotese }}</td>
            </tr>
          </tbody>
        </table>
      </div>

      <p class="sem-dados" *ngIf="resumoDataRegistroOrfa && !listaDataRegistroOrfa?.length">
        Nenhuma atividade órfã no período filtrado.
      </p>
    </div>
  </section>

  <section class="conteudo-relatorio painel-data-registro-orfa" *ngIf="ativarPainelDuplicatasPrevencaoPoc">
    <div class="container">
      <div class="resumo-orfa" *ngIf="resumoDuplicatasPrevencaoPoc">
        <p><b>Total candidatos:</b> {{ resumoDuplicatasPrevencaoPoc.totalCandidatos }}</p>
        <p><b>Grupos duplicados:</b> {{ resumoDuplicatasPrevencaoPoc.totalGrupos }}</p>
        <p><b>Sugeridos para inativar:</b> {{ resumoDuplicatasPrevencaoPoc.totalSugeridosInativar }}</p>
        <p><b>Selecionados:</b> {{ totalDuplicatasSelecionadas }}</p>
      </div>

      <div class="tabela-orfa" *ngIf="listaDuplicatasPrevencaoPoc?.length">
        <table>
          <thead>
            <tr>
              <th>
                <label class="checkbox-label">
                  <input
                    type="checkbox"
                    class="checkbox"
                    [checked]="selecionarTodosDuplicatas"
                    (change)="toggleSelecionarTodosDuplicatas()" />
                  <i></i>
                </label>
              </th>
              <th>Cdg. Visita</th>
              <th>Manter sugerido</th>
              <th>Grupo</th>
              <th>POC</th>
              <th>Data</th>
              <th>Duração</th>
              <th>Tipo atividade</th>
              <th>URE</th>
              <th>Escola</th>
              <th>Aprovação PEC</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let item of listaDuplicatasPrevencaoPoc" [class.sugerido-manter]="item.manterSugerido">
              <td>
                <label class="checkbox-label">
                  <input
                    type="checkbox"
                    class="checkbox"
                    [checked]="!!item.selecionado"
                    (change)="item.selecionado = $any($event.target).checked; onSelecaoDuplicataAlterada()" />
                  <i></i>
                </label>
              </td>
              <td>{{ item.codigoAtividadePoc }}</td>
              <td>{{ item.manterSugerido ? 'Sim' : 'Não' }}</td>
              <td>{{ item.totalNoGrupo }} (mais antigo: {{ item.codigoAtividadePocMaisAntigo }})</td>
              <td>{{ item.nomePoc }}</td>
              <td>{{ item.dataAtividade | date:'dd/MM/yyyy' }}</td>
              <td>{{ item.tempoAtividade }}</td>
              <td>{{ item.tipoAtividadeRealizadaDescricao }}</td>
              <td>{{ item.nomeDiretoria }}</td>
              <td>{{ item.nomeEscola }}</td>
              <td>{{ item.statusAprovacaoPecDescricao }}</td>
            </tr>
          </tbody>
        </table>
      </div>

      <p class="sem-dados" *ngIf="resumoDuplicatasPrevencaoPoc && !listaDuplicatasPrevencaoPoc?.length">
        Nenhum duplicado de Visita de Prevenção POC no período filtrado.
      </p>
    </div>
  </section>

  <section class="conteudo-relatorio painel-data-registro-orfa" *ngIf="ativarPainelCorrecaoCamposAcoesPmce">
    <div class="container">
      <div class="resumo-orfa" *ngIf="listaAcoesPmceCamposVazios?.length">
        <p><b>Ações com campos vazios:</b> {{ listaAcoesPmceCamposVazios.length }}</p>
        <p class="aviso-pmce">Consulta somente leitura — exibe ações com Público, Parceria, Responsável ou Bimestre sem preenchimento.</p>
      </div>

      <div class="tabela-orfa tabela-acoes-pmce" *ngIf="listaAcoesPmceCamposVazios?.length">
        <table>
          <thead>
            <tr>
              <th>Plano</th>
              <th>Escola</th>
              <th>Ação</th>
              <th>Tema (resumo)</th>
              <th>Público</th>
              <th>Parceria</th>
              <th>Responsável</th>
              <th>Bimestre</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let item of listaAcoesPmceCamposVazios">
              <td>{{ item.codigoPlanoMelhoria }}</td>
              <td>{{ item.nomeEscola }}</td>
              <td>{{ item.codigoPlanoMelhoriaAcao }}</td>
              <td class="tema-resumo" [title]="item.temaResumo">{{ item.temaResumo }}…</td>
              <td [class.campo-vazio]="item.publicoEditavel">
                {{ item.publicoEditavel ? '(vazio)' : nomePublicoPmce(item.publico) }}
              </td>
              <td [class.campo-vazio]="item.outraParceriaEditavel">
                {{ item.outraParceriaEditavel ? '(vazio)' : (item.outraParceria || '—') }}
              </td>
              <td [class.campo-vazio]="item.responsavelEditavel">
                {{ item.responsavelEditavel ? '(vazio)' : (item.responsavel || '—') }}
              </td>
              <td [class.campo-vazio]="item.bimestreEditavel">
                {{ item.bimestreEditavel ? '(vazio)' : nomeBimestrePmce(item.bimestre) }}
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      <p class="sem-dados" *ngIf="ativarPainelCorrecaoCamposAcoesPmce && !listaAcoesPmceCamposVazios?.length">
        Nenhuma ação com campos vazios para o filtro informado.
      </p>
    </div>
  </section>

</form>

<app-modal *ngIf="showModalConfirmacaoCorrecao">
  <div class="container-conviva form-registro modal-envolvidos">
    <div class="header-modal-calendario">
      <h2 class="titulo-page fs-3">
        Confirmar correção de Data Registro?
      </h2>
    </div>
    <div class="mt-4">
      <p class="fs-5">
        Confirma a correção de
        <span class="fw-semibold">{{ listaDataRegistroOrfa.length }}</span>
        atividade(s) sem Data Registro?
      </p>
      <p class="fs-5 mt-3">
        <span class="fs-5 fw-semibold">Atenção:</span>
        a Data Registro será preenchida com a Data da Atividade. Essa ação não poderá ser desfeita pela tela.
      </p>
    </div>
    <div class="mt-4">
      <div class="alert alert-primary" role="alert">
        <div class="d-flex align-items-center">
          <svg style="width:20px;" xmlns="http://www.w3.org/2000/svg" class="bi flex-shrink-0 me-2" viewBox="0 0 16 16" role="img" aria-label="Warning:">
            <path d="M8.982 1.566a1.13 1.13 0 0 0-1.96 0L.165 13.233c-.457.778.091 1.767.98 1.767h13.713c.889 0 1.438-.99.98-1.767L8.982 1.566zM8 5c.535 0 .954.462.9.995l-.35 3.507a.552.552 0 0 1-1.1 0L7.1 5.995A.905.905 0 0 1 8 5zm.002 6a1 1 0 1 1 0 2 1 1 0 0 1 0-2z" />
          </svg>
          <div class="m-0 text-justify">
            Serão corrigidos apenas Acolhimentos Agendados sem log de auditoria no período filtrado.
          </div>
        </div>
      </div>
    </div>
    <div class="d-flex mt-5 justify-content-end">
      <input type="button" class="btn_primary fs-4 me-4" value="Cancelar" (click)="FecharModalConfirmacaoCorrecao()" aria-label="Cancelar" />
      <input type="button" class="btn_outline fs-4" value="Confirmar" (click)="ConfirmarCorrecaoDataRegistroOrfa()" aria-label="Confirmar" />
    </div>
  </div>
</app-modal>

<app-modal *ngIf="showModalConfirmacaoInativacaoDuplicatas">
  <div class="container-conviva form-registro modal-envolvidos">
    <div class="header-modal-calendario">
      <h2 class="titulo-page fs-3">
        Confirmar inativação de duplicados?
      </h2>
    </div>
    <div class="mt-4">
      <p class="fs-5">
        Confirma a inativação de
        <span class="fw-semibold">{{ totalDuplicatasSelecionadas }}</span>
        registro(s) de Visita de Prevenção POC?
      </p>
      <p class="fs-5 mt-3">
        <span class="fs-5 fw-semibold">Atenção:</span>
        os registros selecionados deixarão de aparecer na Listagem de Visitas (soft-delete). Essa ação não poderá ser desfeita pela tela.
      </p>
    </div>
    <div class="mt-4">
      <div class="alert alert-primary" role="alert">
        <div class="d-flex align-items-center">
          <svg style="width:20px;" xmlns="http://www.w3.org/2000/svg" class="bi flex-shrink-0 me-2" viewBox="0 0 16 16" role="img" aria-label="Warning:">
            <path d="M8.982 1.566a1.13 1.13 0 0 0-1.96 0L.165 13.233c-.457.778.091 1.767.98 1.767h13.713c.889 0 1.438-.99.98-1.767L8.982 1.566zM8 5c.535 0 .954.462.9.995l-.35 3.507a.552.552 0 0 1-1.1 0L7.1 5.995A.905.905 0 0 1 8 5zm.002 6a1 1 0 1 1 0 2 1 1 0 0 1 0-2z" />
          </svg>
          <div class="m-0 text-justify">
            Serão inativados apenas os registros marcados. O mais antigo de cada grupo é sugerido para manter.
          </div>
        </div>
      </div>
    </div>
    <div class="d-flex mt-5 justify-content-end">
      <input type="button" class="btn_primary fs-4 me-4" value="Cancelar" (click)="FecharModalConfirmacaoInativacaoDuplicatas()" aria-label="Cancelar" />
      <input type="button" class="btn_outline fs-4" value="Confirmar" (click)="ConfirmarInativacaoDuplicatasVisitaPrevencaoPoc()" aria-label="Confirmar" />
    </div>
  </div>
</app-modal>

<ngx-spinner
  bdColor="rgba(51,51,51,0.8)"
  size="medium"
  color="#fff"
  type="ball-scale-multiple"
>
  <p style="font-size: 20px; color: white">Carregando ...</p>
</ngx-spinner>
